if (!customElements.get('after-pay')) {
  customElements.define(
    'after-pay',
    class Afterpay extends HTMLElement {
      constructor() {
        super();
        this.openBtn = this.querySelector('.afterpay__btn');
        this.mobileInfo = this.querySelector('.afterpay-info__mobile');
        this.desktopInfo = this.querySelector('.afterpay-info__desktop');
        this.modal = this.querySelector('.afterpay-modal');
        this.modalContent = this.modal.querySelector('.afterpay-modal-inner');
        this.closeBtn = this.modal.querySelector('.afterpay-modal__close');

        this.modal.setAttribute('role', 'dialog');
        this.modal.setAttribute('aria-modal', 'true');
        this.modal.setAttribute('aria-hidden', 'true');

        this._boundOpen = this.openHandler.bind(this);
        this._boundClose = this.closeHandler.bind(this);
        this._boundKey = this.keyHandler.bind(this);

        this.openBtn.addEventListener('click', this._boundOpen);
        this.modal.addEventListener('click', this._boundClose);
        document.addEventListener('keydown', this._boundKey);
      }

      openHandler() {
        document.body.appendChild(this.modal);

        this.lastFocused = document.activeElement;
        this.modal.classList.add('open');
        this.modal.setAttribute('aria-hidden', 'false');

        if (!this.modal.contains(this.mobileInfo)) {
          this.modalContent.appendChild(this.mobileInfo);
        }
        if (!this.modal.contains(this.desktopInfo)) {
          this.modalContent.appendChild(this.desktopInfo);
        }

        this.trapFocus();
        this.firstFocusable.focus();
      }

      closeHandler(e) {
        if (e.target === this.modal || this.closeBtn.contains(e.target)) {
          this.closeModal();
        }
      }

      keyHandler(e) {
        if (e.key === 'Escape') {
          this.closeModal();
        }
        if (e.key === 'Tab') this.handleTabKey(e);
      }

      closeModal() {
        this.modal.classList.remove('open');
        this.modal.setAttribute('aria-hidden', 'true');

        if (this.lastFocused) this.lastFocused.focus();

        this.appendChild(this.modal);
      }

      trapFocus() {
        this.focusableSelectors = [
          'a[href]',
          'button:not([disabled])',
          'textarea',
          'input:not([disabled])',
          'select:not([disabled])',
          '[tabindex]:not([tabindex="-1"])',
        ];

        this.focusableElements = Array.from(
          this.modal.querySelectorAll(this.focusableSelectors.join(',')),
        );

        this.firstFocusable = this.focusableElements[0];
        this.lastFocusable = this.focusableElements[this.focusableElements.length - 1];
      }

      handleTabKey(e) {
        if (!this.modal.classList.contains('open')) return;

        const isForward = !e.shiftKey;

        if (isForward && document.activeElement === this.lastFocusable) {
          e.preventDefault();
          this.firstFocusable.focus();
        }

        if (!isForward && document.activeElement === this.firstFocusable) {
          e.preventDefault();
          this.lastFocusable.focus();
        }
      }

      disconnectedCallback() {
        this.openBtn.removeEventListener('click', this._boundOpen);
        this.modal.removeEventListener('click', this._boundClose);
        document.removeEventListener('keydown', this._boundKey);
      }
    },
  );
}
